export const iso = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
export const parse = (s) => new Date(`${s}T12:00:00`);
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const monday = (d) => addDays(d, -((d.getDay() + 6) % 7));

export const rangeFor = (view, anchor) => {
  if (view === "day") return [anchor, anchor];
  if (view === "week") { const m = monday(anchor); return [m, addDays(m, 4)]; }
  const first = new Date(anchor.getFullYear(), anchor.getMonth(), 1, 12);
  const last = new Date(anchor.getFullYear(), anchor.getMonth() + 1, 0, 12);
  return [monday(first), addDays(monday(last), 4)];
};

export const step = (view, anchor, dir) => {
  if (view === "day") { let d = addDays(anchor, dir); while (d.getDay() === 0 || d.getDay() === 6) d = addDays(d, dir); return d; }
  if (view === "week") return addDays(anchor, 7 * dir);
  return new Date(anchor.getFullYear(), anchor.getMonth() + dir, 1, 12);
};

export const label = (view, anchor) => {
  if (view === "day") return anchor.toLocaleDateString([], { weekday: "long", month: "long", day: "numeric" });
  if (view === "week") { const [a, b] = rangeFor("week", anchor); return `${a.toLocaleDateString([], { month: "short", day: "numeric" })} – ${b.toLocaleDateString([], { month: "short", day: "numeric" })}`; }
  return anchor.toLocaleDateString([], { month: "long", year: "numeric" });
};

export const byDate = (items) => items.reduce((m, i) => ({ ...m, [i.date]: [...(m[i.date] || []), i] }), {});
